import { render, staticRenderFns } from "./updateSubPaymentDetails.vue?vue&type=template&id=1aa4ffdc&scoped=true&"
import script from "./updateSubPaymentDetails.vue?vue&type=script&lang=js&"
export * from "./updateSubPaymentDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa4ffdc",
  null
  
)

export default component.exports